<template>
  <article>
    <header class="title-bar">
      <h2>排量和年款</h2>
    </header>
    <ul class="car-list car-list01">
      <li v-for="(item, index) in models" :key="index" @click.stop="selModel(item.id)">
        <a href="javascript:void(0);">{{item.name}}</a>
      </li>
    </ul>
  </article>
</template>
<script>
import cache from '../../../common/cache'

export default {
  data () {
    return {
      originUrl: 'originUrl',
      sessionKey: 'saleManageModels',
      seriesId: '',
      models: []
    }
  },
  created () {
    this.seriesId = this.$route.params.seriesId
    if (this.seriesId) {
      this.$rest.saleManage.getCarModelList({ mode: 'compatibility' }, this.seriesId + '/models').then((res) => {
        if (res.code === 0) {
          this.models = res.models
        } else {
          this.showToast(res.message)
        }
      })
    }
  },
  methods: {
    selModel (id) {
      let jup = cache.getSessionData(this.originUrl)
      if (jup) {
        if (!jup.includeColor) {
          this.$router.push({ path: jup.path, query: { modelId: id } })
        } else {
          this.$router.push({ path: '/salemanage/car/outer', query: { id: id } })
        }
      }
    }
  }
}
</script>
